import React, { useState } from 'react';

import useCsvData from '~/core/scripts/hooks/useCsvData';
import ChoroplethMapWidget from '~/core/scripts/widgets/ChoroplethMapWidget';

export default (props) => {
  const data = useCsvData('rechtslinks.csv');

  return (
      <ChoroplethMapWidget
        data={data}
        minZoom={6}
        maxZoom={14}
        choroplethSource="data/landtagswahl_th.topo.json"
        showBasemap={false}
        showMapToggleButton={false}
        showGeocoder={false}
        showLegend={false}
        colorKey="color"
        legendMinLabel="Min Label %"
        legendMaxLabel="Max Label €"
        showLabels
        labelPreset="thueringen"
        customLabels={[]}
        zoomControl={false}
      />
  );
};
